import { useEffect } from "react";
import { StepContainer } from "../components/StepContainer";
import type { StepConfig } from "../config/steps";

export interface PlaceholderStepProps {
  step: StepConfig;
  onValidityChange: (valid: boolean) => void;
  onAttemptContinue: (continueFn: () => Promise<boolean>) => void;
}

export function PlaceholderStep({ step, onValidityChange, onAttemptContinue }: PlaceholderStepProps) {
  useEffect(() => {
    onValidityChange(true);
    onAttemptContinue(async () => true);
  }, [onValidityChange, onAttemptContinue]);

  return (
    <StepContainer icon={step.icon} headline={step.headline} sub={step.sub}>
      <p className="text-sm text-muted-foreground">Em breve nesta sprint.</p>
    </StepContainer>
  );
}
